import axios from "../config/axios-chatbot";

// Message protection password of a registry (usermanagement) project: /api/project/{projectId}/protection,
// with X-Project-Id equal to the path id.
const base = (projectId) => `/api/project/${projectId}/protection`;
const config = (projectId) => ({headers: {"X-Project-Id": projectId}});

export const FlowProtectionRepository = {
    getStatus: (projectId) => axios.get(base(projectId), config(projectId)),
    setPassword: ({projectId, password}) => axios.post(base(projectId), {password}, config(projectId)),
    updatePassword: ({projectId, oldPassword, newPassword}) =>
        axios.put(base(projectId), {oldPassword, newPassword}, config(projectId)),
    authenticate: ({projectId, password}) => axios.post(`${base(projectId)}/auth`, {password}, config(projectId)),
}
